import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const steps = [
  {
    step: '1. Contact Our Support Team',
    description:
      'Send us a data deletion request by reaching out through our Contact Us page. Include your full name and the email address associated with your account.',
  },
  {
    step: '2. Verify Your Identity',
    description:
      'To protect your data, we may ask you to verify your identity before processing your request. Our support team will guide you through this process.',
  },
  {
    step: '3. Confirmation',
    description:
      'Once your request is verified, we will process the deletion within 30 days and send you a confirmation email when it is complete.',
  },
];

const HowToRequest = () => {
  const navigate = useNavigate();

  return (
    <Container id="how-to-request">
      <Box sx={{ my: 5 }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
        >
          How to Request Data Deletion
        </Typography>

        {steps.map((item) => (
          <Box key={item.step} sx={{ my: 3 }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, textAlign: 'left', mb: 1 }}
            >
              {item.step}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                color: 'text.secondary',
              }}
            >
              {item.description}
            </Typography>
          </Box>
        ))}

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/contact-us')}
            sx={{ textTransform: 'none', fontWeight: 600 }}
          >
            Contact Support
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default HowToRequest;
